import { render, staticRenderFns } from "./absence_pending_data_list.vue?vue&type=template&id=c8a75d1e"
import script from "./absence_pending_data_list.vue?vue&type=script&lang=js"
export * from "./absence_pending_data_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports